import React from 'react';
import imageSrc from '../../utils/imageData';

function getCountryFlag(countryCode) {
  // Convert country code to regional indicator symbols
  // Each regional indicator symbol is 127397 codepoints after its corresponding ASCII letter
  const offset = 127397;
  const firstChar = countryCode.charCodeAt(0) + offset;
  const secondChar = countryCode.charCodeAt(1) + offset;
  
  return String.fromCodePoint(firstChar) + String.fromCodePoint(secondChar);
}

function OrgsTableItem({ organization, type, handleSelect, handleEdit, handleDelete, isSelected }) {
  return (
    <tr>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
        <div className="flex items-center">
          <label className="inline-flex">
            <span className="sr-only">Select</span>
            <input 
              className="form-checkbox" 
              type="checkbox" 
              checked={isSelected} 
              onChange={() => handleSelect(organization.id)} 
            />
          </label>
        </div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="flex items-center">
          {organization.logo && (
            <div className="pr-2 w-20 shrink-0 mr-2 sm:mr-3">
              <img 
                className="rounded-full" 
                src={imageSrc(organization.logo)}
                alt={organization.name} 
              />
            </div>
          )}
          <div className="font-medium text-slate-800 dark:text-slate-100">{organization.name}</div>
        </div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-left flex items-center">
          <span className="mr-2 text-xl" title={organization.country}>
            {organization.country ? getCountryFlag(organization.country) : ''}
          </span>
          {organization.country}
        </div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className={`inline-flex font-medium rounded-full text-center px-2.5 py-0.5 ${
          organization.status != 'active' 
            ? 'bg-emerald-100 dark:bg-emerald-400/30 text-emerald-600 dark:text-emerald-400' 
            : 'bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400'
        }`}>
          Active
          {/*{organization.status === 'active' ? 'Active' : 'Inactive'}*/}
        </div>
      </td>
      
      {type === 'business' && (
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left">{organization.sector}</div>
        </td>
      )}
      
      {type === 'regulator' && (
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left">{organization.jurisdiction}</div>
        </td>
      )}
      
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
        <div className="space-x-1">
          <button
            className="text-slate-400 hover:text-slate-500 dark:text-slate-500 dark:hover:text-slate-400 rounded-full"
            onClick={() => handleEdit(organization)}
          >
            <span className="sr-only">Edit</span>
            <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
              <path d="M19.7 8.3c-.4-.4-1-.4-1.4 0l-10 10c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4l-4-4zM12.6 22H10v-2.6l6-6 2.6 2.6-6 6zm7.4-7.4L17.4 12l1.6-1.6 2.6 2.6-1.6 1.6z" />
            </svg>
          </button>
          <button
            className="text-rose-400 hover:text-rose-500 dark:text-rose-500 dark:hover:text-rose-400 rounded-full"
            onClick={() => handleDelete(organization)}
          >
            <span className="sr-only">Delete</span>
            <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
              <path d="M13 15h2v6h-2zM17 15h2v6h-2z" />
              <path d="M20 9c0-.6-.4-1-1-1h-6c-.6 0-1 .4-1 1v2H8v2h1.1l1 10c0 .6.4 1 1 1h9.8c.6 0 1-.4 1-1l1-10H23v-2h-3V9zm-6 1h4v1h-4v-1zm7.1 3l-1 9H11.9l-1-9h10.2z" />
            </svg>
          </button>
        </div>
      </td>
    </tr>
  );
}

export default OrgsTableItem;